import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { SentryIcon, SentrySearchResultIcon } from './icon';

export const sentryConfig: ThirdPartyConfig = {
	displayName: 'Sentry',
	id: 'sentry',
	resourceType: ProductResourceTypes3P.Sentry,
	icon: get3PLogo(SentryIcon, 'Sentry', 'medium'),
	searchResultIcon: get3PLogo(SentrySearchResultIcon, 'Sentry', 'large'),
	integrationAri: 'ari:cloud:platform::integration/sentry',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
